// Interface Special Project
import { RcFile } from 'antd/es/upload';
export interface ISpecialProjectFilter {
  usernames: {
    id: string;
    displayName: string;
  }[];
}
export interface ISpecialProjectList {
  id: string;
  scannedBy: ISpecialProjectScannerBy;
  scannedDate: string;
  totalMAJFiles: number;
  totalSketchFiles: number;
  excel: boolean;
  drawing: boolean;
  majFile: boolean;
}

export interface ISpecialProjectScannerBy {
  id: string;
  firstName: string;
  lastName: string;
}

export interface ISpecialProjectDetailResponse {
  items: ISpecialProjectDetail[];
  meta: {
    totalRecords: number;
  };
}

export interface ISpecialProjectDetail {
  id: string;
  jobId: string;
  jobCode: string;
  noNumber: 10;
  projectName: string;
  poNumber: string;
  dueDate: string;
  orderDate: string;
  status: SpecialProjectStatusEnum;
  confirmDelivery: boolean;
  state: string;
  companyName: string;
  qcDate: string;
  deliveryDate: string;
  nonQC: boolean;
  drawing: SpecialProjectStatusColorEnum;
  majFile: SpecialProjectStatusColorEnum;
  majFiles: Array<IMajFiles>;
  drawingLink: string;
  invoiced: boolean;
  invoicedScanDate?: string;
  jobNotes: string;
  deliveryNotes: string;
  orderByName: string;
  projectManagerName: string;
  projectId: string;
}

export enum SpecialProjectStatusColorEnum {
  Blue = 'Blue',
  Gray = 'Gray',
}

export enum SpecialProjectStatusEnum {
  InProduction = 'InProduction',
  Ready = 'Ready',
  RequiredBooking = 'RequiredBooking',
  DeliveryBooked = 'DeliveryBooked',
  Delivered = 'Delivered',
  Completed = 'Completed',
  OnHold = 'OnHold',
  Exception = 'Exception',
  Canceled = 'Canceled',
}

export enum UploadStatus {
  UploadFailed = 'UploadFailed',
  Uploading = 'Uploading',
  Uploaded = 'Uploaded',
}

export interface IMajUploadModal {
  detailId?: string;
  onClose: () => void;
  onFinished: (values: string[]) => void;
  remainFiles?: number;
  existedFileNames: string[];
}

export interface IMajUploadResponses {
  category: string;
  extension: string;
  id: string;
  name: string;
  objectId: string;
  originalName: string;
  progressId: string;
  status: string;
  uploadedBy: string;
}

export interface ISuccessUploadRendering {
  detailId?: string;
  specialProjectId?: string;
  fileIds?: string[];
  onClose: () => void;
}

interface IMajFiles {
  extension: string;
  id: string;
  originalName: string;
  relativePath: string;
  size: number;
}

export interface IViewDetailUploadRendering {
  majFiles: Array<IMajFiles>;
  detailId?: string;
  onClose: () => void;
  onSave: () => void;
}

// Interface extending RcFile with optional upload response
export interface IRcFileManage extends RcFile {
  response?: IMajUploadResponses;
}

// Upload tracking structure for successful/failed uploads
export interface IManageUploadStatus {
  progressId: string;
  fileId: string;
  filename: string;
}
